module.exports = __webpack_public_path__ + "static/media/Galdisa_Oil roasted redskin peanut.fa4bc2e8.pdf";